// CSS
import 'normalize.css';
// FIXMEreplace Hammer and delete prop-types
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import store from './store/index';
import RootGuard from './components/RootGuard';
import { initStoreListeners } from './store/initListeners';
// import * as Hammer from 'hammerjs';
// window.Hammer = Hammer.default;
// eslint-disable-next-line no-console
console.log(`%c v${version}-${buildId} `, 'background: #e0ebeb; color: #262626;');
initStoreListeners();
document.title = 'Communicator';
const container = document.getElementById('root');
const root = createRoot(container);
root.render(React.createElement(Provider, { store: store },
    React.createElement(RootGuard, null)));
